import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {MessageComponent, BaseComponent} from '../common/common-components';
import {DictionaryService} from "../services/dictionary-service";
import {MessageService} from "../services/message-service";
import {HarmonogramService} from "./harmonogram-service";
import {BankAccountService} from "../accounts/bank-account-service";
import {Router} from '@angular/router';
import {UserService} from '../user/user-service';

let _ : any = require("lodash");
let dateformat = require("dateformat");

@Component({
    selector: 'dk-harmonogram-edit',
    template: require('./harmonogram-edit.html'),
    providers: [DictionaryService, HarmonogramService, BankAccountService]
})

export class HarmonogramEditComponent extends BaseComponent implements OnInit {
    public errorMessageId: string;

    public exchangeModes: any[];
    public types: any[];
    public subTypes: any[];
    public currencies: any[];
    public bankCodes: any[];
    public rememberEmails: any[];
    public hours: any[];
    public repetitionPeriods: any[];
    public loaded: boolean = false;
    public account: any = null;
    public showThirdPartyTransferAccept: boolean = false;
    protected previousTypeID: any;
    protected previousSubTypeID: any;
    protected previousCurrencyID: any;
    protected previousExchangeMode: any;

    form: FormGroup = new FormGroup({
        HarmonogramID: new FormControl(null),
        TypeID: new FormControl('1', Validators.required),
        SubTypeID: new FormControl('1', Validators.required),
        Amount: new FormControl(1000, Validators.required),
        CurrencyID: new FormControl(null, Validators.required),
        BankCodeID: new FormControl(null, this.requiredIfExchangeModeBankAccount()),
        TransferTitle: new FormControl('Wymiana', [this.requiredIfExchangeModeBankAccount(), Validators.minLength(1), Validators.maxLength(120)]),
        ExchangeMode: new FormControl('1', Validators.required),
        ExchangeDate: new FormControl(dateformat('yyyy-mm-dd'), this.requiredIfSubTypeSelectedDay()),
        ExchangeTime: new FormControl('09:05:00', this.requiredIfSubTypeSelectedDay()),
        ExchangeFirstDate: new FormControl(dateformat(new Date(new Date().getTime() + 24 * 60 * 60 * 1000), 'yyyy-mm-dd'), this.requiredIfSubTypePeriodicallyOnSelectedDay()),
        ExchangeLastDate: new FormControl(dateformat(new Date(new Date().getTime() + 24 * 60 * 60 * 1000), 'yyyy-mm-dd'), this.requiredIfSubTypePeriodicallyOnSelectedDay()),
        RepetitionPeriodID: new FormControl('1', this.requiredIfSubTypePeriodicallyOnSelectedDay()),
        RememberEmailID: new FormControl('1', Validators.required),
        ExchangeRateTreshold: new FormControl(null, this.requiredIfSubTypeWithExchangeRate()),
        ThirdPartyTransferAccepted: new FormControl(false)
    });

    constructor (private harmonogramService: HarmonogramService, private messageService: MessageService,
                 private dictionaryService: DictionaryService, private route: ActivatedRoute,
                 private bankAccountService: BankAccountService, private router: Router, private userService:UserService) {
        super();
    }

    public ngOnInit() {
        this.types = [];

        this.types.push({
            Id: "1",
            Name: "Harmonogram.TypeCurrencyPurchase"
        });

        this.types.push({
            Id: "2",
            Name: "Harmonogram.TypeCurrencySale"
        });

        this.subTypes = [];

        this.subTypes.push({
            Id: "1",
            Name: "Harmonogram.SubTypeOnSelectedDay"
        });

        this.subTypes.push({
            Id: "2",
            Name: "Harmonogram.SubTypePeriodicallyOnSelectedDay"
        });

        this.subTypes.push({
            Id: "3",
            Name: "Harmonogram.SubTypeWithExchangeRate"
        });

        this.exchangeModes = [];

        this.exchangeModes.push({
            Id: "1",
            Name: "Harmonogram.ExchangeModeBankAccount"
        });

        this.exchangeModes.push({
            Id: "2",
            Name: "Harmonogram.ExchangeModeCantorAccount"
        });

        this.rememberEmails = [];

        this.rememberEmails.push({
            Id: "1",
            Name: "Harmonogram.RememberEmailNoReminder"
        });

        this.rememberEmails.push({
            Id: "2",
            Name: "Harmonogram.RememberEmailOneDayBefore"
        });

        this.rememberEmails.push({
            Id: "3",
            Name: "Harmonogram.RememberEmailTwoDaysBefore"
        });

        this.rememberEmails.push({
            Id: "4",
            Name: "Harmonogram.RememberEmailThreeDaysBefore"
        });

        this.repetitionPeriods = [];

        this.repetitionPeriods.push({
            Id: "1",
            Name: "Harmonogram.RepetitionPeriodDaily"
        });

        this.repetitionPeriods.push({
            Id: "2",
            Name: "Harmonogram.RepetitionPeriodEveryWeek"
        });

        this.repetitionPeriods.push({
            Id: "3",
            Name: "Harmonogram.RepetitionPeriodEveryTwoWeeks"
        });

        this.repetitionPeriods.push({
            Id: "4",
            Name: "Harmonogram.RepetitionPeriodEveryMonth"
        });

        this.hours = ["09:05:00","09:30:00","10:00:00","10:30:00","11:00:00","11:30:00","12:00:00","12:30:00","13:00:00","13:30:00","14:00:00",
            "14:30:00","15:00:00","15:30:00","16:00:00"];

        this.bankAccountService.getCurrencies().subscribe(result => {
            for (var item of result) {
                item.SymbolName = `${item.Symbol} (${item.Name})`;
            }
            this.currencies = result;

            if (this.currencies[0]) {
                this.currencyControl.setValue(this.currencies[0].CurrencyID);
            }

            let id = this.route.snapshot.params['id'];

            if (id) {
                this.load(id);
            } else {
                this.loaded = true;
                this.loadAccounts();
                this.setLoadedSubscriptions();
            }
        });

        this.userService.account().subscribe(data => {
            this.account = data;
        });
        
        this.form.controls['BankCodeID'].valueChanges.subscribe(bankCodeId => {
            if(bankCodeId){
                let bankCode = _.find(this.bankCodes, q => q.BankCodeID == bankCodeId);
                this.showThirdPartyTransferAccept = bankCode.ThirdParty === 1;
            }
        });
    }

    public loadAccounts() {
        this.getAccounts(this.form.controls['CurrencyID'].value);
    }

    public setLoadedSubscriptions() {
        this.form.controls['TypeID'].valueChanges.subscribe(newValue => {
            //console.log('TypeID changes', this.previousTypeID, newValue, typeof this.previousTypeID, typeof newValue);
            if (this.previousTypeID !== newValue) {
                //console.log("A");
                this.getLastExchangeRate(newValue, this.form.controls['CurrencyID'].value);
            }
            this.previousTypeID = newValue;
        });

        this.form.controls['CurrencyID'].valueChanges.subscribe(newValue => {
            //console.log('CurrencyID changes', this.previousCurrencyID, newValue, typeof this.previousCurrencyID, typeof newValue);
            if (this.previousCurrencyID !== newValue) {
                //console.log("B");
                this.getLastExchangeRate(this.form.controls['TypeID'].value, newValue);
            }
            this.previousCurrencyID = newValue;
        });

        this.form.controls['SubTypeID'].valueChanges.subscribe(newValue => {
            if (this.previousSubTypeID !== newValue) {
                this.getLastExchangeRate(this.form.controls['TypeID'].value, this.form.controls['CurrencyID'].value);
            }
            this.previousSubTypeID = newValue;
        });

        this.form.controls['CurrencyID'].valueChanges.subscribe(newValue => {
            this.form.controls['BankCodeID'].setValue(null);
            this.getAccounts(newValue);
        });

        this.form.controls['TypeID'].valueChanges.subscribe(newValue => {
            this.form.controls['BankCodeID'].setValue(null);
            this.getAccounts(this.form.controls['CurrencyID'].value);
        });

        this.form.controls['ExchangeMode'].valueChanges.subscribe(newValue => {
            if (this.previousExchangeMode !== newValue) {
                //It is here, because there is a problem with validation when ExchangeMode changes. It has to be triggered manually.
                setTimeout(() => { this.updateValueAndValidity(this.form); });
            }

            this.previousExchangeMode = newValue;
        });
    }

    public getAccounts(currencyId) {
        currencyId = this.form.controls['TypeID'].value === '1' ? currencyId : 1 /*PLN*/;

        this.bankAccountService.bankCodesForCurrency(currencyId).subscribe(bankCodes => {
            this.bankCodes = bankCodes;
            
            if (!this.form.controls['BankCodeID'].value) {
                if (bankCodes.length == 1) {
                    this.form.controls['BankCodeID'].setValue(bankCodes[0].BankCodeID);
                }
            }
        });
    }

    public getLastExchangeRate(typeId, currencyId) {
        if (this.isSubTypeWithExchangeRate) {
            let masterCurrencyId = this.isSubTypeWithExchangeRate ? 1 : currencyId;
            let slaveCurrencyId = this.isSubTypeWithExchangeRate ? currencyId : 1;
            this.harmonogramService.lastExchangeRate(masterCurrencyId, slaveCurrencyId).subscribe(value => {
                this.form.controls['ExchangeRateTreshold'].setValue(value.Rate);
            });
        }
    }

    public get isTypeCurrencyPurchase(): boolean {
        return this.form.controls['TypeID'].value == "1";
    }

    public get isExchangeModeBankAccount(): boolean {
        return this.form.controls['ExchangeMode'].value == "1";
    }

    public get isSubTypeSelectedDay(): boolean {
        return this.form.controls['SubTypeID'].value == "1";
    }

    public get isSubTypePeriodicallyOnSelectedDay(): boolean {
        return this.form.controls['SubTypeID'].value == "2";
    }

    public get isSubTypeWithExchangeRate(): boolean {
        return this.form.controls['SubTypeID'].value == "3";
    }

    get currencyControl(): FormControl {
        return this.form.controls['CurrencyID'] as FormControl;
    }

    get selectedCurrencySymbol(): string {
        let result = _(this.currencies).find(item => item.CurrencyID == this.currencyControl.value);
        if (result) {
            return result.Symbol;
        }

        return '';
    }

    get selectedCurrencyMultiplier(): string {
        let result = _(this.currencies).find(item => item.CurrencyID == this.currencyControl.value);
        if (result) {
            return result.Multiplier;
        }

        return '';
    }

    get exchangeDateControl(): FormControl {
        return this.form.controls['ExchangeDate'] as FormControl;
    }

    get exchangeFirstDateControl(): FormControl {
        return this.form.controls['ExchangeFirstDate'] as FormControl;
    }

    get exchangeLastDateControl(): FormControl {
        return this.form.controls['ExchangeLastDate'] as FormControl;
    }

    get exchangeDateRangeInvalid(): boolean {
        return (!this.exchangeFirstDateControl.valid && this.exchangeFirstDateControl.touched) || (!this.exchangeLastDateControl.valid && this.exchangeLastDateControl.touched);
    }

    load(id) {
        return this.harmonogramService.get(id).subscribe(item => {
            if (item.TypeID) {
                item.TypeID = item.TypeID.toString();
            }

            if (item.SubTypeID) {
                item.SubTypeID = item.SubTypeID.toString();
            }

            if (item.RepetitionPeriodID) {
                item.RepetitionPeriodID = item.RepetitionPeriodID.toString();
            }

            this.previousTypeID = item.TypeID;
            this.previousSubTypeID = item.SubTypeID;
            this.previousCurrencyID = item.CurrencyID;
            this.previousExchangeMode = item.ExchangeMode;

            this.initFormGroup(this.form, item);

            this.loaded = true;
            this.loadAccounts();
            this.setLoadedSubscriptions();
        });
    }

    submit() {
        this.touchFormGroup(this.form);

        if (this.form.valid) {
            var harmonogram = this.form.value;

            this.errorMessageId = null;

            if (harmonogram.CurrencyID != null) {
                harmonogram.CurrencyID = parseInt(harmonogram.CurrencyID);
            }

            if (harmonogram.BankCodeID != null) {
                harmonogram.BankCodeID = parseInt(harmonogram.BankCodeID);
            }

            this.harmonogramService.edit(harmonogram).subscribe(() => {
                this.messageService.success('Harmonogram.DataSavedSuccessfully');
                this.router.navigate(['/panel-klienta/zlecenia-stale.html']);
            },(error) => {
                this.messageService.errorByMessageId(error.messageId);
            });
        }
    }

    cancel() {

    }

    requiredIfSubTypeSelectedDay() {
        return (c: FormControl) => {
            if (this.form) {
                return !this.isSubTypeSelectedDay || (c.value != null) ? null : {
                    requiredIfSubTypeSelectedDay: {
                        valid: false
                    }
                };
            }
        }
    }

    requiredIfSubTypePeriodicallyOnSelectedDay() {
        return (c: FormControl) => {
            if (this.form) {
                return !this.isSubTypePeriodicallyOnSelectedDay || (c.value != null) ? null : {
                    requiredIfSubTypePeriodicallyOnSelectedDay: {
                        valid: false
                    }
                };
            }
        }
    }

    requiredIfSubTypeWithExchangeRate() {
        return (c: FormControl) => {
            if (this.form) {
                return !this.isSubTypeWithExchangeRate || (c.value != null) ? null : {
                    requiredIfSubTypeWithExchangeRate: {
                        valid: false
                    }
                };
            }
        }
    }

    requiredIfExchangeModeBankAccount() {
        return (c: FormControl) => {
            if (this.form) {
                return !this.isExchangeModeBankAccount || (c.value != null) ? null : {
                    requiredIfExchangeModeBankAccount: {
                        valid: false
                    }
                };
            }
        }
    }
}
